import React from 'react';
import { reports } from '../../hooks';

import {
  ExtensionRequestsReportMobile,
  LateResponsesReportMobile,
  OutstandingResponsesReportMobile,
  RespondedYearToDateReportMobile,
  RespondedOnTimeReportMobile,
} from '../reports';

export const MobileReportFiltersModal: React.FC<{ reportName: reports }> = ({
  reportName,
}) => {
  switch (reportName) {
    case reports.extensionRequests:
      return <ExtensionRequestsReportMobile />;
    case reports.lateResponses:
      return <LateResponsesReportMobile />;
    case reports.outstandingResponses:
      return <OutstandingResponsesReportMobile />;
    case reports.respondedOnTime:
      return <RespondedOnTimeReportMobile />;
    case reports.respondedYearToDate:
      return <RespondedYearToDateReportMobile />;
    default:
      return <></>;
  }
};
